import logo from './logo.svg';
import './App.css';
import Navbar from "./components/Navbar";
import MiddleSection from "./components/MiddleSection";
import Steps from "./components/Steps";
import AboutUs from "./components/AboutUs";
import Footer from "./components/Footer";
import HowItWorks from "./components/HowItWorks";

function App() {
  return (
    <div className="App">
      <div className="min-h-screen bg-gray-50">
<Navbar />
<MiddleSection />
<Steps />
<AboutUs />
<HowItWorks />
<Footer />

</div>
    </div>
  );
}

export default App;
